import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPencilLine: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPencilLine"><Path d="M17 2.5L21.5 7L7 21.5H2.5V17L17 2.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M11.5 21.5H21.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPencilLine;
